import { useEffect } from 'react';

const JsonLd = ({ data }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    script.setAttribute('data-jsonld', 'true');
    document.head.appendChild(script);
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [data]);

  return null;
};

export const WebsiteJsonLd = ({ siteSettings }) => {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Carvalho Comercio - Melhores Ofertas e Achadinhos',
    url: window.location.origin,
    description: 'O Carvalho Achados é um site de recomendações que seleciona produtos com base em avaliações e custo-benefício. Compre com segurança nas plataformas parceiras.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${window.location.origin}/ofertas?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  return <JsonLd data={data} />;
};

export const OrganizationJsonLd = () => {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Carvalho Comercio',
    url: window.location.origin,
    logo: 'https://res.cloudinary.com/dcu6hlupu/image/upload/w_300,f_auto,q_auto/v1774552342/carvalho-deals/brand/logo.png',
    sameAs: ['https://www.instagram.com/carvalhocomercio'],
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'carvalhocomercio7@gmail.com',
      contactType: 'customer service',
    },
  };

  return <JsonLd data={data} />;
};

export const ProductListJsonLd = ({ products }) => {
  if (!products || !Array.isArray(products) || products.length === 0) return null;

  const data = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Melhores Ofertas do Dia',
    numberOfItems: products.length,
    itemListElement: products.map((product, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Product',
        name: product.name,
        image: product.image_url,
        description: product.description || product.name,
        offers: {
          '@type': 'Offer',
          price: product.current_price,
          priceCurrency: 'BRL',
          availability: 'https://schema.org/InStock',
          url: product.affiliate_link,
          ...(product.old_price && product.old_price > product.current_price
            ? { priceValidUntil: new Date(Date.now() + 7 * 86400000).toISOString().split('T')[0] }
            : {}),
        },
        ...(product.platform
          ? { brand: { '@type': 'Brand', name: product.platform } }
          : {}),
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.8',
          reviewCount: '150',
        },
      },
    })),
  };

  return <JsonLd data={data} />;
};

export default JsonLd;
